import React, { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CookiesKeys, URLs } from '../../Constants/Consts'
import { fetchApi } from '../../Helpers/Functions'
import { RootState } from '../../store/store'
import Cookies from "js-cookie";
import { addAccessLevels } from '../../store/AccessLevel'

export default function storeAccessLevel() {

    const [isloading, setIsloading] = React.useState(false)
    const dispatch = useDispatch()
    const { downloadTriggered: { accessLevels: triggered } } = useSelector(
        (state: RootState) => state.Utilities
    );
    const calledOnceRef = useRef(false)
    const currentToken = Cookies.get(CookiesKeys.jwt)

    React.useEffect(() => {
        (async () => {
            try {
                if (navigator.onLine && currentToken && (!calledOnceRef.current || triggered)) {
                    calledOnceRef.current = true
                    setIsloading(true)
                    const accessLevels = await fetchApi(
                        URLs.getAccessLevels())
                        .then(res => res.json())
                    // update store
                    dispatch(addAccessLevels(accessLevels))
                    setIsloading(false)
                }
            } catch (error) {
                console.error("error from download access levels", error);
            }
        })()
    }, [currentToken, triggered])
    return { isloading }
}
